import { FrontEndModel } from '@/models/FrontEndModel';

export class EventSponsorModel extends FrontEndModel {
    name!: string;
    description?: string;
    url?: string;
    logoUrl?: string;
}